import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { Observable, Subject, Subscription } from 'rxjs';

import {
  Swiper,
  Navigation,
  Pagination,
  FreeMode,
  A11y,
  Controller,
  Thumbs,
  HashNavigation,
} from 'swiper';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { SwiperModule } from 'swiper/angular';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

Swiper.use([Navigation, Pagination, FreeMode, A11y, Controller, Thumbs, HashNavigation]);

@Component({
  selector: 'popsy-gallery',
  templateUrl: './gallery.template.html',
  styleUrls: ['./gallery.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, NgIf, SwiperModule, NgFor, SpinnerComponent, AsyncPipe],
})
export class GalleryComponent implements OnDestroy {
  @Input() public pictures?: Array<{
    src: string;
    thumb: string;
  }> | null;

  @Input() public wideMode?: boolean | null = false;

  @ViewChild('splideContainer') public splideContainerRef?: ElementRef | null;
  @ViewChild('splidePreviewsContainer')
  public splidePreviewsContainerRef?: ElementRef | null;

  public thumbsSwiper: any;

  public lessThan$: Observable<ScreenSizeInfoState>;
  public biggerThan$: Observable<ScreenSizeInfoState>;
  public rtlLayout$: Observable<boolean>;

  private readonly screenSizeSubscriber?: Subscription | null;

  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.destroySubject = new Subject();
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.rtlLayout$ = this.akitaRouterQuery.selectIsRtlLayout();
  }

  public trackByPicture(
    index: number,
    picture?: { src: string; thumb: string } | null
  ): string {
    return picture?.src || picture?.thumb || `${index}`;
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();

    if (this.screenSizeSubscriber) {
      this.screenSizeSubscriber.unsubscribe();
    }
  }
}
